import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'container',
    'order',
    'list',
    'input',
    'inputTemplate',
    'currentInputContainer',
    'listTemplate',
    'dropContainer',
    'dropFieldImage',
    'uploadingImage',
    'uploadedImage',
    'descriptionContainer',
    'uploadedFilename',
  ];

  connect() {
    this.reorder();
    this.addDropEvents();
    this.dragCounter = 0;
  }

  clickUploadButtonHandler() {
    this.inputTarget.click();
  }

  inputHandler(e) {
    for (let i = 0; i < e.currentTarget.files.length; i += 1) {
      const file = e.currentTarget.files[i];
      this.addFileToList(file);
    }

    this.inputTarget.files = null;
    this.inputTarget.value = null;
    this.reorder();
  }

  addFileToList(file) {
    const newInput = this.inputTemplateTarget.cloneNode();
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    newInput.files = dataTransfer.files;

    const newListItem = this.listTemplateTarget.cloneNode(true);
    newListItem.appendChild(newInput);
    newListItem.querySelector('.filename').innerHTML = file.name;
    newListItem.setAttribute('data-file-upload-target', 'listItem');
    newListItem.classList.remove('hidden');
    this.listTarget.appendChild(newListItem);
  }

  removeFile(e) {
    const target = e.currentTarget;
    target.closest("[data-file-upload-target='listItem']").remove();
    this.reorder();
  }

  reorder() {
    let counter = 0;
    this.orderTargets.forEach((target) => {
      target.innerHTML = `${counter}.`;
      counter += 1;
    });

    if (this.orderTargets.length === 1) { // only template
      this.listTarget.classList.add('hidden');
    } else {
      this.listTarget.classList.remove('hidden');
    }
  }

  displayDragAndDropField() {
    if (this.dragCounter > 0) {
      this.dropContainerTarget.classList.remove('hidden');
      this.dropFieldImageTarget.classList.remove('hidden');
      this.descriptionContainerTarget.classList.add('hidden');
    } else {
      this.dropContainerTarget.classList.add('hidden');
      this.dropFieldImageTarget.classList.add('hidden');
      this.uploadingImageTarget.classList.add('hidden');
      this.uploadedImageTarget.classList.add('hidden');
      this.descriptionContainerTarget.classList.remove('hidden');
    }
  }

  addDropEvents() {
    const container = this.containerTarget;

    container.addEventListener('dragenter', (e) => {
      e.preventDefault();
      this.dragCounter += 1;
      this.displayDragAndDropField();
    });

    container.addEventListener('dragover', (e) => {
      e.preventDefault();
    });

    container.addEventListener('dragleave', () => {
      this.dragCounter -= 1;
      this.displayDragAndDropField();
    });

    container.addEventListener('drop', (e) => {
      e.preventDefault();

      this.dragCounter = 0;
      const { files } = e.dataTransfer;
      if (!files || files.length === 0) {
        this.displayDragAndDropField();
        return;
      }

      if (files.length === 1) {
        this.uploadedFilenameTarget.innerHTML = files[0].name;
      } else {
        this.uploadedFilenameTarget.innerHTML = `${files.length}個のファイル`;
      }

      this.dropFieldImageTarget.classList.add('hidden');
      this.uploadingImageTarget.classList.remove('hidden');

      this.inputTarget.files = files;
      this.inputTarget.dispatchEvent(new Event('input'));

      this.uploadingImageTarget.classList.add('hidden');
      this.uploadedImageTarget.classList.remove('hidden');

      setTimeout(() => { this.displayDragAndDropField(); }, 2000);
    });
  }
}
